import * as DialogPrimitive from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui'

interface ExpandedArtifactDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  headerActions?: ReactNode
  children: ReactNode
}

// Built from Radix primitives instead of our app-wide Dialog wrapper so we
// fully own the layout: the close button lives inside the header as a flex
// sibling of the title, guaranteeing they share a baseline.
export default function ExpandedArtifactDialog({
  open,
  onOpenChange,
  title,
  headerActions,
  children,
}: ExpandedArtifactDialogProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-[overlay-enter_0.15s_ease-out_forwards] data-[state=closed]:animate-[overlay-exit_0.15s_ease-in_forwards]" />
        <DialogPrimitive.Content className="fixed left-1/2 top-1/2 z-50 flex h-[85vh] w-[calc(100%-2rem)] max-w-6xl -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-lg border bg-card shadow-lg data-[state=open]:animate-[dialog-enter_0.15s_ease-out_forwards] data-[state=closed]:animate-[dialog-exit_0.15s_ease-in_forwards]">
          <div className="flex shrink-0 items-center gap-3 border-b px-4 py-3">
            <DialogPrimitive.Title className="min-w-0 flex-1 truncate text-sm font-medium">
              {title}
            </DialogPrimitive.Title>
            {headerActions ? (
              <span className="flex shrink-0 items-center gap-0.5">
                {headerActions}
              </span>
            ) : null}
            <DialogPrimitive.Close asChild>
              <Button
                type="button"
                theme="ghost"
                size="sm"
                isIcon
                className="shrink-0"
                aria-label="Close"
              >
                <X className="size-4" />
              </Button>
            </DialogPrimitive.Close>
          </div>
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
